import * as api from "@services/api";

const dependencies = {
  api,
};

export default dependencies;
